import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.gsdcadmin.community.users');
import { OnInit, OnDestroy, Input } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { Router } from '@angular/router'

@Component({
    selector: 'wiz-portal-gsdcadmin-community-users',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.gsdcadmin.community.users/view.scss */
.leader-notice {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem 0.75rem;
  margin: 0 0 1rem;
  padding: 0.875rem 1rem;
  border: 1px solid var(--gsdc-border, #d5e1ec);
  border-radius: 0.75rem;
  background: var(--gsdc-card, #f4f8fc);
  color: var(--gsdc-text, #24384c);
  overflow-wrap: anywhere;
}
.leader-notice.is-warning {
  border-color: #c99132;
}
.leader-notice.is-error {
  border-color: #c45454;
}
.leader-notice a {
  text-decoration: underline;
  font-weight: 600;
}

input:disabled {
  cursor: wait;
  opacity: 0.6;
}`],
})
export class PortalGsdcadminCommunityUsersComponent implements OnInit, OnDestroy {

    constructor(@Inject( Service) public service: Service,@Inject( Router)  private router: Router) { }

    @Input() community_id: any;
    public users: any = [];
    public community: any = {};

    public pagination: any = {
        page: 1,
        start: 1,
        end: 1
    }
    public searchTerm = "";
    public total = 0;

    public async ngOnInit() {
        await this.service.init();
        await this.load();
    }

    public async load() {
        const { code, data } = await wiz.call("load", { text: this.searchTerm, page: this.pagination.page, communityID: this.community_id });
        if (code != 200) return window.location="/dashboard";
        this.users = data.users;
        this.community = data.community;
        this.pagination.page = data.page || this.pagination.page;
        this.pagination.start = Math.floor((this.pagination.page - 1) / 10) * 10 + 1;
        this.pagination.end = data.lastpage;
        this.total = data.total;
        await this.service.render();
    }

    private async pageLoad(p: number) {
        this.pagination.page = p;
        await this.load();
    }

    public leaderChanging = false;
    public leaderNotice = '';
    public leaderNoticeKind = '';
    public leaderNoticeUser = '';

    public async changeLeader(user: any, event: Event) {
        const checkbox = event.target as HTMLInputElement;
        const original = user.representative === 'Y' ? 'Y' : 'N';
        const next = checkbox.checked ? 'Y' : 'N';
        checkbox.checked = original === 'Y';
        if (this.leaderChanging || next === original) return;

        this.leaderChanging = true;
        this.leaderNotice = '';
        this.leaderNoticeKind = '';
        this.leaderNoticeUser = user.full_name || user.account_name || '';
        try {
            await this.service.render();
            const confirmed = await this.service.alert.show({
                title: next === 'Y' ? '연구커뮤니티 대표 지정' : '연구커뮤니티 대표 해제',
                message: next === 'Y' ? '해당 사용자를 연구커뮤니티 대표로 지정하시겠습니까?' : '해당 사용자의 연구커뮤니티 대표 지정을 해제하시겠습니까?',
                action: next === 'Y' ? '지정' : '해제', cancel: '취소',
                actionBtn: next === 'Y' ? 'success' : 'error', status: next === 'Y' ? 'success' : 'error'
            });
            if (confirmed !== true) return;

            let response: any;
            try {
                response = await wiz.call('changeLeader', {
                    user: JSON.stringify({id: user.id, member_id: user.member_id, representative: next}),
                    community: JSON.stringify({id: this.community.id || this.community_id})
                });
            } catch (_) {
                this.leaderNotice = '처리 결과를 확인하지 못했습니다. 새로고침해 대표 상태를 확인해주세요.';
                this.leaderNoticeKind = 'error';
            }

            if (response) {
                const data = response.data;
                if (response.code !== 200 || !(data === true || (data && typeof data === 'object'))) {
                    this.leaderNotice = (typeof data === 'string' ? data : data?.message) || '연구커뮤니티 대표 지정/해제에 실패했습니다.';
                    this.leaderNoticeKind = 'error';
                } else {
                    user.representative = next;
                    checkbox.checked = next === 'Y';
                    this.leaderNotice = data?.message || '연구커뮤니티 대표 지정/해제를 완료했습니다.';
                    this.leaderNoticeKind = data?.notification_status && !['sent', 'no_recipients', 'unchanged', 'not_required'].includes(data.notification_status) ? 'warning' : 'success';
                }
            } else if (!this.leaderNotice) {
                this.leaderNotice = '처리 결과를 확인하지 못했습니다. 새로고침해 대표 상태를 확인해주세요.';
                this.leaderNoticeKind = 'error';
            }
        } finally {
            this.leaderChanging = false;
            await this.service.render();
        }
        if (this.leaderNoticeKind === 'error') await this.service.alert.error(this.leaderNotice);
        else if (this.leaderNoticeKind === 'warning') await this.service.alert.warning(this.leaderNotice);
        else await this.service.alert.success(this.leaderNotice);
    }
}

export default PortalGsdcadminCommunityUsersComponent;